
// Classes creation for concepts
$(document).ready(function () {
    if ($(body).hasClass('saffire-layouts')) {

        $('.layout-container').before('<div class="dividerLine-top"></div>')
        $('.dynamicPageContainer .sectionHeading').each(function () {
            const text = $(this).text().replace(/{|}/g, '');

            switch (text) {
                case 'concept1-dark':
                case 'concept1-light':
                case 'concept2-dark':
                case 'concept2-light':
                case 'concept3-dark':
                case 'concept3-light':
                case 'concept4-dark':
                case 'concept4-light':
                case 'concept5-dark':
                case 'concept5-light':
                case 'concept6-dark':
                case 'concept6-light':
                case 'concept7-dark':
                case 'concept7-light':
                    $(this).parent('.entityContainerRow').addClass(`layout-sample ${text}`);
                    $(this).css('display', 'none');
                    $(this).parent('.entityContainerRow').append('<div class="dividerLine-bottom"></div>');
                    break;
                default:
                    break;
            }

        });

        // Color and concept selector

        // Setting default color and concept on load by default
        $('.concept1-light').addClass('sample-show');

        // default values on load
        let themeValue = "light";
        let conceptValue = "concept1";

        // Theme Selector Funcion
        function themeSelector(e) {
            e.preventDefault();
            themeValue = $(this).attr('id');
            $(".btn-container .button").removeClass("active-theme");
            $(this).addClass("active-theme");

            if (themeValue === "dark") {
                $("#switch-themes .button").find('.scheme-update').text("Light");
            } else {
                $("#switch-themes .button").find('.scheme-update').text("Dark");
            }

            if ($('.layout-sample').hasClass('sample-show')) {
                $('.layout-sample.sample-show').fadeOut('slow', function () {
                    $(this).removeClass('sample-show');
                    $(`.${conceptValue}-${themeValue}`).addClass('sample-show');
                    $(`.${conceptValue}-${themeValue}`).fadeIn('slow');
                });
            } else {
                $(`.${conceptValue}-${themeValue}`).addClass('sample-show');
                $(`.${conceptValue}-${themeValue}`).fadeIn('slow');
            }
        }

        // Concept Selector Funcion
        function conceptSelector(e) {
            e.preventDefault();
            conceptValue = $(this).attr('id');


            $(".layout-container .button").removeClass("active-layout");
            $(this).addClass("active-layout");


            if ($('.layout-sample').hasClass('sample-show')) {
                $('.layout-sample.sample-show').fadeOut('slow', function () {
                    $(this).removeClass('sample-show');
                    $(`.${conceptValue}-${themeValue}`).addClass('sample-show');
                    $(`.${conceptValue}-${themeValue}`).fadeIn('slow');
                });

            } else {
                $(`.${conceptValue}-${themeValue}`).addClass('sample-show');
                $(`.${conceptValue}-${themeValue}`).fadeIn('slow');
            }
        }

        // Switching option for color theme -- check btn enabled on html spark
        $("#switch-themes .button").click(function (e) {
            e.preventDefault();
            if (themeValue === "dark") {
                $('.btn-container #dark').removeClass('active-theme');
                $('.btn-container #light').addClass('active-theme');
                themeValue = "light";
                $(this).find('.scheme-update').text("Dark");

                $('.layout-sample.sample-show').fadeOut('slow', function () {
                    $(this).removeClass('sample-show');
                    $(`.${conceptValue}-${themeValue}`).addClass('sample-show');
                    $(`.${conceptValue}-${themeValue}`).fadeIn('slow');
                });

            } else {
                $('.btn-container #light').removeClass('active-theme');
                $('.btn-container #dark').addClass('active-theme');
                themeValue = "dark";
                $(this).find('.scheme-update').text("Light");

                $('.layout-sample.sample-show').fadeOut('slow', function () {
                    $(this).removeClass('sample-show');
                    $(`.${conceptValue}-${themeValue}`).addClass('sample-show');
                    $(`.${conceptValue}-${themeValue}`).fadeIn('slow');
                });

            }
        });

        // Theme selector
        $(".btn-container .button").on('keypress click', function (e) {
            if (e.key == 'Enter' || e.type == 'click') {
                themeSelector.call(this, e);
            }
        })

        // Concept selector
        $(".layout-container .button").on('keypress click', function (e) {
            if (e.key == 'Enter' || e.type == 'click') {
                conceptSelector.call(this, e);

            }
        });
    }
});
